import { InjectionToken } from '@angular/core';

export const FILE_PREVIEW_DIALOG_DATA = new InjectionToken<any>('FILE_PREVIEW_DIALOG_DATA');
export const FILE_PREVIEW_DIALOG_AUTOCOMPLETE = new InjectionToken<any>('FILE_PREVIEW_DIALOG_AUTOCOMPLETE');
export const FILE_PREVIEW_DIALOG_MULTISELECT = new InjectionToken<any>('FILE_PREVIEW_DIALOG_MULTISELECT');
